const asNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
};

const rowValue = (row, ...keys) => {
    for (const key of keys) {
        if (row?.[key] != null) {
            return row[key];
        }
    }
    return undefined;
};

export const placementLabel = (placement) => ({
    HOME_SCREEN: "Home",
    EVENT_PAGE: "Event",
    PROFILE_PAGE: "Schedule details",
    SPONSOR_SECTION: "Logo strip",
}[placement] || placement);

export const summarizeAdAnalytics = ({ daily = {}, revenue = {} } = {}) => {
    const impressions = asNumber(daily.totalImpressions);
    const clicks = asNumber(daily.totalClicks);
    const ctr = asNumber(daily.overallCTR);
    const totalRevenue = asNumber(revenue.totalRevenue);
    return {
        impressions,
        clicks,
        ctr,
        revenue: totalRevenue,
        currency: revenue.currency || "USD",
        year: revenue.year ?? null,
        hasActivity: impressions > 0 || clicks > 0 || totalRevenue > 0,
    };
};

export const dailySeries = (daily = {}) => {
    const rows = Array.isArray(daily.dailyStats) ? daily.dailyStats : [];
    return {
        labels: rows.map((row) => String(rowValue(row, "stat_date", "statDate") || "")),
        impressions: rows.map((row) => asNumber(rowValue(row, "total_impressions", "totalImpressions"))),
        clicks: rows.map((row) => asNumber(rowValue(row, "total_clicks", "totalClicks"))),
    };
};

export const ctrSeries = (ctr = {}) => {
    const entries = Object.entries(ctr || {}).filter(([, value]) => value != null && typeof value !== "object");
    return {
        labels: entries.map(([placement]) => placementLabel(placement)),
        values: entries.map(([, value]) => Math.round(asNumber(value) * 1000) / 10),
    };
};

export const revenueSeries = (revenue = {}) => {
    const rows = Array.isArray(revenue.monthlyRevenue) ? revenue.monthlyRevenue : [];
    return {
        labels: rows.map((row) => row.monthName || String(row.month || "")),
        values: rows.map((row) => asNumber(rowValue(row, "total_revenue", "totalRevenue"))),
    };
};
